export default __webpack_public_path__ + "static/product_category_hospital-bafa5083165ea5a92dc9530781bce944.jpg";